"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCheckPhoneChangeDto = instanceOfCheckPhoneChangeDto;
exports.CheckPhoneChangeDtoFromJSON = CheckPhoneChangeDtoFromJSON;
exports.CheckPhoneChangeDtoFromJSONTyped = CheckPhoneChangeDtoFromJSONTyped;
exports.CheckPhoneChangeDtoToJSON = CheckPhoneChangeDtoToJSON;
exports.CheckPhoneChangeDtoToJSONTyped = CheckPhoneChangeDtoToJSONTyped;
/**
 * Check if a given object implements the CheckPhoneChangeDto interface.
 */
function instanceOfCheckPhoneChangeDto(value) {
    if (!('phone' in value) || value['phone'] === undefined)
        return false;
    return true;
}
function CheckPhoneChangeDtoFromJSON(json) {
    return CheckPhoneChangeDtoFromJSONTyped(json, false);
}
function CheckPhoneChangeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'phone': json['phone'],
    };
}
function CheckPhoneChangeDtoToJSON(json) {
    return CheckPhoneChangeDtoToJSONTyped(json, false);
}
function CheckPhoneChangeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'phone': value['phone'],
    };
}
